import type { ContainerProps as MantineContainerProps } from '@mantine/core';
import { Container, rem } from '@mantine/core';

type ContainerProps = MantineContainerProps;

const CONTAINER_SIZES: Record<string, string> = {
  xs: rem(540),
  sm: rem(720),
  md: rem(960),
  lg: rem(1140),
  // TODO: update container size (with default?) to match design ... all consumer app pages match 1220, as does nav
  xl: rem(1550),
};

const ContainerDefaults = Container.extend({
  vars: (_, { size, fluid }) => ({
    root: {
      '--container-size': fluid
        ? '100%'
        : size !== undefined && size in CONTAINER_SIZES
          ? CONTAINER_SIZES[size]
          : rem(size),
    },
  }),
});

export { Container, ContainerDefaults };
export type { ContainerProps };
